const ACFBlockMediaTextVideo = (blockElem) => {

	const coreMediaEl = blockElem.querySelector('.core-media-text-video');
	if(!coreMediaEl) {
		return;
	}

	const placeHolder = coreMediaEl.querySelector('.placeholder');
	if(placeHolder) {
		const src = placeHolder.getAttribute('data-src');
		if(src) {
			const poster = coreMediaEl.querySelector('.poster');
			poster.addEventListener('click', (e) => {
				e.preventDefault();

				let videoEl;

				if(!coreMediaEl.classList.contains('js-initialised')) {

					videoEl = document.createElement('video');
					videoEl.src = src;
					videoEl.playsInline = true;
					videoEl.controls = true;
					videoEl.addEventListener('ended', () => coreMediaEl.classList.remove('js-playing'));

					placeHolder.appendChild(videoEl);

					coreMediaEl.classList.add('js-initialised');
				}
				else {
					videoEl = coreMediaEl.querySelector('video');
				}

				videoEl.play();
				coreMediaEl.classList.add('js-playing');

			});
		}
	}
};

export default ACFBlockMediaTextVideo;